<template>
    <modal id="hotel-achievement-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('achievement')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/achievement`'
            @submit.prevent="submitData"
        >
            <!-- <app-form-group
                :label="$t('attachments')"
                type="file"
                v-model="files"
                :multiple="true"
                :placeholder="$placeholder('attachments', '')"
                :file-label="$placeholder('attachments', '')"
                :error-message="$errorMessage(errors, 'files.0')"
            /> -->
            <app-form-group-selectable
                v-if="!hotel_id"
                type="select"
                :label="$t('hotel')"
                list-value-field="name"
                v-model="formData.hotel_id"
                :required="true"
                :chooseLabel="$t('hotel')"
                :error-message="$errorMessage(errors, 'hotel_id')"
                :fetch-url="`${TENANT_BASE_URL}selectable/hotel/list`"
            />
            <app-form-group-selectable
                type="select"
                :label="$t('floor')"
                list-value-field="floor"
                list-value-id="floor"
                v-model="formData.floor"
                :required="true"
                :chooseLabel="$t('floor')"
                :error-message="$errorMessage(errors, 'floor')"
                :fetch-url="room_url"
            />
            <app-form-group
                type="date"
                :label="$t('date')"
                v-model="formData.date"
                :placeholder="formData.date ? $placeholder('date') : this.$t('not_added_yet')"
                :error-message="$errorMessage(errors, 'date')"
            />
            <app-form-group-selectable
                type="multi-select"
                :label="$t('categories')"
                list-value-field="title"
                v-model="formData.categories"
                :chooseLabel="$t('category')"
                :error-message="$errorMessage(errors, 'categories')"
                :fetch-url="`${TENANT_BASE_URL}app/hotel/achievement-category?per_page=0`"
            />
            <app-form-group
                type="textarea"
                v-model="formData.remark"
                :label="$t('remark')"
                :placeholder="$textAreaPlaceHolder('remark')"
                :required="false"
                :error-message="$errorMessage(errors, 'remark')">
            </app-form-group>

            <div class="form-group">
                <label>{{ $t('document') }}</label>
                <app-input
                    type="dropzone"
                    v-model="file"
                    :error-message="$errorMessage(errors, 'file')"
                    :max-files="1"
                />
                <small class="text-muted font-italic mt-3 d-inline-block">
                    {{ $t('document_recommendation') }}
                </small>
            </div>

            <div class="form-group" v-if="current_files.length">
                <label>{{ $t('current_files') }}</label>
                <div class="img-container">
                    <div class="img-box" v-for="(url, index) in current_files" :key="'current-image-' + index">
                        <img v-if="isImage(url)"
                            :src="url"
                            class="img-thumbnail"
                            :title="getFileName(url)"
                        />
                        <div v-else
                            :href="url"
                            target="_blank"
                            class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                            :title="getFileName(url)"
                        >
                            <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                        </div>
                        <div class="img-action">
                            <button type="button" class="btn btn-sm btn-primary" @click="viewFile(url)" :title="$t('view')">
                                <i class="fas fa-eye"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formatDateForServer} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "HotelAchievementCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        hotel_id: {
            default: null
        }
    },
    data() {
        const form = {}

        if (this.hotel_id) {
            form.hotel_id = this.hotel_id
        }

        return {
            TENANT_BASE_URL,
            files   : [],
            room_url: null,
            formData: form,
            file    : null,
            current_files: [],
        }
    },
    watch  : {
        'formData.hotel_id': {
            handler  : function (hotel_id) {
                this.room_url = `${TENANT_BASE_URL}selectable/hotel/room?group=floor&hotel_id=${typeof hotel_id !== "undefined" ? hotel_id : 0}`
            },
            immediate: true
        }
    },
    methods: {
        submitData() {
            this.loading       = true
            this.formData.date = this.formData.date ? formatDateForServer(this.formData.date) : '';

            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.formData.categories) {
                formData.set('categories', JSON.stringify(this.formData.categories))
            }

            this.files.forEach(file => formData.append('files[]', file))

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            if (this.hotel_id) {
                formData.append('hotel_id', this.hotel_id);
            }

            if (this.file) {
                formData.append('files[]', this.file[0]);
            }

            if (!this.formData.remark) {
                formData.delete('remark');
            }

            this.loading = true;

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#hotel-achievement-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'hotel-achievement-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.current_files = response.data.files || [];
            delete response.data.files;
            this.formData  = response.data;
        },
    },
}
</script>